<template>
    <div class="app app-lmu-approval-form">
        <router-view></router-view>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    
    export default {
        name: 'lmu-approval-form-container',
        components: { },
        data() {
            return { }
        },
        computed: {
            ...mapGetters({
                user : 'AuthController/user',
            }),
        },
        watch: { 
            $route: {
                immediate: true,
                handler(to) {
                    document.title = to.meta.title || 'Loading...';
                }
            },
        },
        async created() {
            this.$store.dispatch('AuthController/getUser')
                .then(result => { })
                .catch(error => {
                    return this.logout()
                })
        },
        methods: { },
    }
</script>
